<template>
  <div ref="scroller" class="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm" :style="scrollerWidth ? { '--panel-w': `${scrollerWidth}px` } : undefined">
    <div class="min-w-[880px]" role="table" aria-label="Purchase orders">
      <div :class="GRID_COLUMNS" class="grid items-center gap-3 border-b border-gray-200 px-4 py-2 text-xs font-semibold uppercase tracking-wider text-gray-500" role="row">
        <span role="columnheader"><span class="sr-only">Expand</span></span>
        <span role="columnheader">PO</span>
        <span role="columnheader">Status</span>
        <span role="columnheader">Ship dates</span>
        <span class="text-right" role="columnheader">Shipped / ordered</span>
        <span class="text-right" role="columnheader">To plan</span>
        <span role="columnheader">Needs attention</span>
      </div>
      <div v-if="rows.length === 0" role="row">
        <p class="m-0 px-4 py-8 text-center text-sm text-gray-500" role="cell" :aria-colspan="COLUMN_COUNT">
          {{ emptyText }}
          <button v-if="canShowAll" type="button" class="font-semibold text-blue-700 hover:underline" @click="emit('show-all')">Show all</button>
        </p>
      </div>
      <PoTrackerRow
        v-for="row in rows"
        :key="row.poNumber"
        :row="row"
        :color="colors.get(row.poNumber) ?? ''"
        :expanded="expanded.has(row.poNumber)"
        :show-new="showNew && row.updated"
        @toggle="emit('toggle', row.poNumber)"
        @mark-shipped="emit('mark-shipped', $event)"
        @shipping-details="emit('shipping-details', $event)"
        @request-delivery="emit('request-delivery', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  import PoTrackerRow from '@/components/poTracker/PoTrackerRow.vue';
  import { COLUMN_COUNT, GRID_COLUMNS } from '@/components/poTracker/poTrackerGrid';
  import { useElementWidth } from '@/composables/useElementWidth';
  import type { PoTrackerRow as Row, Shipment, ShippingEvent } from '@/types/poTracker';

  defineProps<{
    rows: Row[];
    colors: Map<string, string>;
    expanded: Set<string>;
    showNew: boolean;
    emptyText: string;
    canShowAll: boolean;
  }>();
  const emit = defineEmits<{
    toggle: [poNumber: string];
    'show-all': [];
    'mark-shipped': [shipment: Shipment];
    'shipping-details': [event: ShippingEvent];
    'request-delivery': [poNumber: string];
  }>();

  // Exposed as --panel-w so an expanded PO sticks to the visible width while the columns scroll.
  const scroller = ref<HTMLElement | null>(null);
  const scrollerWidth = useElementWidth(scroller);
</script>
